import React, { MouseEvent, useMemo } from 'react';
import { useField } from 'react-final-form';

import { InputLabel, Stack, ToggleButtonGroup } from '@mui/material';

type Props = {
  label: string | JSX.Element;
  name: string;
  children: JSX.Element | JSX.Element[];
  defaultValue?: unknown;
};
export default function ToggleButtonInput({ defaultValue, label, name, children }: Props) {
  const { value, onChange } = useField(name).input;

  const v = useMemo(() => {
    if (!defaultValue) {
      return value;
    }
    if (typeof value === 'string' && value.trim().length === 0) {
      return defaultValue;
    }
    return value ?? defaultValue;
  }, [value, defaultValue]);

  const handleChange = (ev: MouseEvent<HTMLElement>, v: unknown) => {
    if (v === null) {
      return;
    }
    onChange(v);
  };

  return (
    <Stack alignItems="flex-start">
      <InputLabel shrink>{label}</InputLabel>
      <ToggleButtonGroup exclusive onChange={handleChange} value={v} fullWidth size="small">
        {children}
      </ToggleButtonGroup>
    </Stack>
  );
}
